import { billing } from "store/requests";

export const fetchPracticeUsers = async (payload) => {
  try {
    let { data } = await billing({
      url: "/fetchPracticeUsers",
      payload,
      addPracticeId: false,
    });
    return data;
  } catch (error) {}
};

export const addPracticeUser = async (payload) => {
  try {
    let { data } = await billing({
      url: "/fetchPracticeUsers",
      payload,
      addPracticeId: false,
    });
    return data;
  } catch (error) {}
};

export const updatePracticeUser = async (payload) => {
  try {
    let { data } = await billing({
      url: "/updatePracticeUser",
      payload,
      addPracticeId: false,
    });
    return data;
  } catch (error) {}
};

export const getPracticeList = async () => {
  try {
    let { data } = await billing({
      url: "/getPracticeList",
      payload: {},
      addPracticeId: false,
    });
    return data;
  } catch (error) {}
};

export const addPractice = async (payload) => {
  try {
    let { data } = await billing({
      url: "/addPractice",
      payload,
      addPracticeId: false,
    });
    return data;
  } catch (error) {}
};

export const addPracticeLocation = async (payload) => {
  try {
    let { data } = await billing({
      url: "/addPracticeLocation",
      payload,
      addPracticeId: false,
    });
    return data;
  } catch (error) {}
};

export const editPractice = async (payload) => {
  try {
    let { data } = await billing({
      url: "/editPractice",
      payload,
      addPracticeId: false,
    });
    return data;
  } catch (error) {}
};

export const getPracticeLocations = async (payload) => {
  try {
    let { data } = await billing({
      url: "/getPracticeLocations",
      payload,
      addPracticeId: false,
    });
    return data;
  } catch (error) {}
};

export const getProviderList = async (payload) => {
  try {
    let { data } = await billing({
      url: "/getProviderList",
      payload,
      addPracticeId: false,
    });
    return data;
  } catch (error) {}
};

export const addProvider = async (payload, setErrorMessage) => {
  try {
    let { data } = await billing({
      url: "/addProvider",
      payload,
      addPracticeId: false,
    });
    return data;
  } catch (error) {
    if (
      error?.response?.data?.error?.includes("Provider.provider_npi_UNIQUE")
    ) {
      setErrorMessage("Provider NPI is already used.");
    } else setErrorMessage("Failed to add provider");
  }
};

export const updateProvider = async (payload) => {
  try {
    let { data } = await billing({
      url: "/updateProvider",
      payload,
      addPracticeId: false,
    });
    return data;
  } catch (error) {}
};
